/* eslint-disable react/self-closing-comp */
import moment from 'moment';
import { formatDate } from '../utils/format';
import { resourceTypes, valuesToHTML, TEMPLATES } from '../utils/health-resources';

export default class ResourceModel {
  properties: {
    [string]: any
  };

  constructor(properties: {}) {
    this.properties = properties || {};
  }

  updateValues(props: any) {
    this.properties = {
      ...this.properties,
      ...props
    };
  }
  // ui properties (normalized across all resource types)
  get title(): String {
    if (typeof this.name === 'string') {
      return this.name;
    }
    const name = (this.name && this.name.text && this.name.text !== undefined) && this.name.text;
    if (name) {
      return name;
    }
    return this.generated.title;
  }

  get type(): String {
    const type = this.properties.resource_type;
    if (resourceTypes[type]) return resourceTypes[type].name;
    return type;
  }

  get color(): String {
    const type = this.properties.resource_type;
    if (type && resourceTypes[type]) return resourceTypes[type].color;
    return resourceTypes.default.color;
  }

  get dateText(): String {
    return formatDate(this.properties.recordedAt) || '';
  }

  get sortByDate(): Date {
    return moment(this.properties.recordedAt);
  }

  get name(): String {
    // if (this.properties.name) return this.properties.name;
    return {
      text: this.generated.title
    };
  }

  get sortingPriority(): Number {
    // 3 (pin to top) - 1 (last)
    return 1;
  }
  // data properties
  get id(): Number {
    return this.properties.id;
  }
  get createdAt(): Date {
    return this.properties.createdAt;
  }
  get practitioner(): Date {
    return this.properties.practitioner;
  }
  get draft(): Date {
    return this.properties.draft;
  }
  get institution_address_id(): Date { // eslint-disable-line
    return this.properties.institution_address_id;
  }
  get institution_name(): String { // eslint-disable-line
    if (this.properties.institution_name) {
      return this.properties.institution_name;
    } else if (this.properties.source === 'maple') {
      return 'Maple';
    }
    return '';
  }
  get patientName(): String {
    return this.properties.patientName;
  }
  get recordedAt(): Date {
    return this.properties.recordedAt || moment().format();
  }
  get reviewed(): Date {
    return this.properties.reviewed;
  }
  get files(): File[] {
    return this.properties.files || [];
  }
  get resource_type(): String { // eslint-disable-line
    return this.properties.resource_type;
  }
  get values(): Object {
    return this.properties.values;
  }
  get generated(): Object {
    return {
      ...TEMPLATES[this.resource_type](this.values),
      text: () => valuesToHTML({ resourceBody: this.values, resourceType: this.resource_type })
    };
  }

  get identifier(): String {
    const id = this.properties.identifier;
    if (id && id.value) {
      return id.value;
    }
    return id || null;
  }

  get generatedText(): String {
    return this.generated.text ? this.generated.text : null;
  }

  get source(): Number {
    return this.properties.source;
  }
  get nested(): Object[] {
    return this.properties.resources;
  }
  get nestedTypes(): string[] {
    const types = this.nested && this.nested.reduce((array, res) => {
      array.push(res.resource_type);
      return Array.from(new Set(array));
    }, []);
    return types;
  }
}



// WEBPACK FOOTER //
// ./src/models/Resource.js